import styled from "styled-components";

const CardViagensDetails = styled.div`
  width: 100%;
  height: 500px;

  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  background-color: #fff;

  border-radius: 16px;
  position: relative;

  transition: all 0.3s;

  cursor: pointer;

  user-select: none;

  &:hover {
    transform: translateY(-6px);
  }

  .image {
    width: 100%;
    position: relative;

    img {
      width: 100%;
      height: 250px;
      object-fit: cover;

      border-radius: 10px 10px 0px 0px;
    }
  }

  .tag {
    padding: 5px 15px;

    text-align: center;

    border-radius: 16px;

    position: absolute;

    bottom: -10px;
    right: 30px;
  }

  .content-card {
    width: 100%;
    padding: 20px;

    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .title {
    font-size: 1rem;
    font-weight: 600;
  }

  .horario {
    display: flex;
    flex-direction: column;
    gap: 10px;

    .icon {
      font-size: 1.3rem;
    }

    .saida,
    .retorno {
      display: flex;
      gap: 10px;
    }
  }

  .preco {
    display: flex;
    flex-direction: column;
    gap: 10px;

    position: absolute;

    bottom: 10px;
    left: 20px;
  }

  .tip-preco {
    width: 70px;
  }

  .preco-div {
    display: flex;
    align-items: center;
    gap: 5px;

    p {
      font-size: 1.5rem;
      font-weight: 600;
    }
  }
`;

export default CardViagensDetails;
